import {inject, Injectable, OnDestroy, ViewChild} from '@angular/core';
import {ChartConfiguration, ChartTypeRegistry}    from 'chart.js';
import {Subject}                                  from 'rxjs';
import {DataFactoryService}                       from '../../logr-services/data/data-factory.service';
import {DataFilterService}                        from '../../logr-services/data/data-filter.service';
import {UiThemeService}                           from '../../logr-ui/utils/ui-theme.service';
import {ChartCompBase}                            from '../tools/chart-comp.base';
import {ChartConfsService}                        from '../tools/chart-confs.service';
import {ChartDefaultsService}                     from '../tools/chart-defaults.service';
import {ChartPropsService}                        from '../tools/chart-props.service';
import {ChartThemeService}                        from '../tools/chart-theme.service';


@Injectable()
export abstract class ChartCatsBase<TChartComp extends ChartCompBase<any, any>, TChartType extends keyof ChartTypeRegistry> implements OnDestroy {
	@ViewChild('ChartComponent') abstract chartComponent: TChartComp;

	public svcChartTheme = inject(ChartThemeService);
	public svcChartConfs = inject(ChartConfsService);
	public svcChartProps = inject(ChartPropsService);
	public svcChartDefaults = inject(ChartDefaultsService);
	public svcDataFilters = inject(DataFilterService)
	public svcDataFactory = inject(DataFactoryService)
	public svcUiTheme = inject(UiThemeService);

	public dataTrash = new Subject<void>();

	public abstract conf: ChartConfiguration<TChartType>;

	ngOnDestroy() {
		this.dataTrash.next();
		this.dataTrash.complete();
	}

}